/**
 * 10-Minute Countdown Timer with localStorage persistence
 * For Black Friday deal validity timer
 */

class DevFridayTimer {
  constructor() {
    this.timerKey = 'dev_friday_timer_start';
    this.durationMs = 10 * 60 * 1000; // 10 minutes in milliseconds
    this.elements = {
      minutes: null,
      seconds: null,
      container: null
    };
    this.interval = null;
    this.startTime = null;
    this.endTime = null;
    
    this.init();
  }

  init() {
    // Find timer elements
    this.elements.container = document.querySelector('[data-dev-friday-timer]');
    if (!this.elements.container) return;

    this.elements.minutes = this.elements.container.querySelector('[data-timer-minutes]');
    this.elements.seconds = this.elements.container.querySelector('[data-timer-seconds]');

    if (!this.elements.minutes || !this.elements.seconds) return;

    this.initializeTimer();
    this.startCountdown();
  }

  initializeTimer() {
    // Check if timer already exists in localStorage
    const storedStartTime = localStorage.getItem(this.timerKey);
    const now = Date.now();

    if (storedStartTime) {
      this.startTime = parseInt(storedStartTime);
      this.endTime = this.startTime + this.durationMs;
      
      // Check if timer has expired
      if (now >= this.endTime) {
        this.resetTimer();
      }
    } else {
      this.resetTimer();
    }
  }

  resetTimer() {
    const now = Date.now();
    this.startTime = now;
    this.endTime = now + this.durationMs;
    localStorage.setItem(this.timerKey, this.startTime.toString());
  }

  startCountdown() {
    this.updateDisplay();
    
    this.interval = setInterval(() => {
      this.updateDisplay();
    }, 1000);
  }

  updateDisplay() {
    const now = Date.now();
    const remaining = Math.max(0, this.endTime - now);

    if (remaining <= 0) {
      this.onTimerExpired();
      return;
    }

    const minutes = Math.floor(remaining / (1000 * 60));
    const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

    // Update display with zero-padding
    this.elements.minutes.textContent = minutes.toString().padStart(2, '0');
    this.elements.seconds.textContent = seconds.toString().padStart(2, '0');
  }

  onTimerExpired() {
    clearInterval(this.interval);
    
    // Display expired state
    this.elements.minutes.textContent = '00';
    this.elements.seconds.textContent = '00';
    
    // Add expired class for styling
    this.elements.container.classList.add('timer-expired');
    
    // Show urgency message
    this.showUrgencyMessage();
  }

  showUrgencyMessage() {
    // Find or create urgency message element
    let urgencyElement = document.querySelector('[data-timer-urgency]');
    
    if (!urgencyElement) {
      urgencyElement = document.createElement('div');
      urgencyElement.setAttribute('data-timer-urgency', '');
      urgencyElement.className = 'dev-friday-urgency-message';
      urgencyElement.innerHTML = '<strong>⏰ Time\'s up! Complete your purchase ASAP to secure these deals!</strong>';
      
      // Insert after timer container
      this.elements.container.parentNode.insertBefore(urgencyElement, this.elements.container.nextSibling);
    }
    
    urgencyElement.style.display = 'block';
    urgencyElement.classList.add('urgency-active');
  }

  // Public method to reset timer manually if needed
  reset() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    localStorage.removeItem(this.timerKey);
    this.initializeTimer();
    this.startCountdown();
  }

  // Public method to get remaining time
  getRemainingTime() {
    const now = Date.now();
    return Math.max(0, this.endTime - now);
  }

  // Public method to check if timer is expired
  isExpired() {
    return this.getRemainingTime() <= 0;
  }
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.devFridayTimer = new DevFridayTimer();
});

// Also initialize immediately if DOM is already loaded
if (document.readyState === 'loading') {
  // DOM is still loading, wait for DOMContentLoaded
} else {
  // DOM is already loaded
  window.devFridayTimer = new DevFridayTimer();
}
